import { getDeliveries, createDelivery, updateDelivery, deleteDelivery } from '../models/deliveryModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchDeliveries(page, perPage) {
  try {
    const response = await getDeliveries(page, perPage);
    return {
      delivery: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching deliveries:", error);
    Swal.fire('Error', 'No se pudieron cargar las entregas', 'error');
    return null;
  }
}

export async function saveDelivery(delivery, currentDeliveryId) {
  try {
    if (currentDeliveryId) {
      await updateDelivery(currentDeliveryId, delivery);
      toasts.add({
        title: 'Éxito',
        description: 'Entrega guardada exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      await createDelivery(delivery);
      toasts.add({
        title: 'Éxito',
        description: 'Entrega creada exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
  } catch (error) {
    console.error("Error saving delivery:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar la entrega',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }
}

export async function removeDelivery(id) {
  try {
    await deleteDelivery(id);
    toasts.add({
      title: 'Éxito',
      description: 'Entrega eliminada exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting delivery:", error);
    Swal.fire('Error', 'No se pudo eliminar la entrega', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'delivery'
export function subscribeToDeliveries(searchQuery, handleSearch) {
  pb.collection('delivery').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromDeliveries() {
  pb.collection('delivery').unsubscribe('*');
}

export async function searchDeliveries(query, page = 1, perPage = 10) {
  const response = await pb.collection('delivery').getList(page, perPage, {
    filter: `nombre ~ "${query}"`,
  });
  return {
    delivery: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}